import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo, forwardRef } from "react";
import Icon from "../../Icon/Icon";
var BoltStyle1ActiveNatureIcon = /*#__PURE__*/forwardRef(function (properties, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("path", {
    d: "M13.684 2.35a1.059 1.059 0 011.78 1.081L13 10h4.865a1 1 0 01.768 1.64l-8.32 9.983a1.046 1.046 0 01-1.783-1.037L11 14H6.445a1.445 1.445 0 01-1.074-2.412l8.313-9.237z",
    fill: "currentColor"
  }));
});
export default /*#__PURE__*/memo(BoltStyle1ActiveNatureIcon);